"use client";

import { useEffect, useRef } from "react";
import Image from "next/image";

const avatars = [
  { src: "/avatar-1.png", alt: "Nöjd kund" },
  { src: "/avatar-2.png", alt: "Nöjd kund" },
  { src: "/avatar-3.png", alt: "Nöjd kund" },
  { src: "/avatar-4.png", alt: "Nöjd kund" },
  { src: "/avatar-5.png", alt: "Nöjd kund" },
];

import type { Locale } from "./templates/ServicePageTemplate";

const trustT = {
  sv: { heading: "Bli en av våra", highlight: "nöjda kunder", altAvatar: "Nöjd kund" },
  en: { heading: "Join our", highlight: "happy customers", altAvatar: "Happy customer" },
};

export default function TrustpilotReviews({ locale = "sv", headingText, highlightText }: { locale?: Locale; headingText?: string; highlightText?: string }) {
  const l = { ...trustT[locale], ...(headingText && { heading: headingText }), ...(highlightText && { highlight: highlightText }) };
  const tpLocale = locale === "en" ? "en-US" : "sv-SE";
  const desktopRef = useRef<HTMLDivElement>(null);
  const mobileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const w = window as unknown as { Trustpilot?: { loadFromElement: (el: HTMLElement, flag: boolean) => void } };
    if (w.Trustpilot) {
      if (desktopRef.current) w.Trustpilot.loadFromElement(desktopRef.current, true);
      if (mobileRef.current) w.Trustpilot.loadFromElement(mobileRef.current, true);
    }
  }, []);

  return (
    <section id="reviews" className="py-8 sm:pt-10 sm:pb-24 bg-white">
      <div className="mx-auto max-w-screen-2xl px-6 xl:px-14">
        {/* Heading with avatars */}
        <div className="text-center mb-10 sm:mb-14">
          <div className="flex justify-center -space-x-3 mb-6">
            {avatars.map((avatar, i) => (
              <div
                key={i}
                className="relative h-14 w-14 rounded-full ring-1 ring-brand-secondary overflow-hidden bg-gray-200"
              >
                <Image
                  src={avatar.src}
                  alt={avatar.alt}
                  fill
                  className="object-cover"
                />
              </div>
            ))}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-dark">
            {l.heading}{" "}
            <span className="bg-brand-primary px-3 py-1 rounded-md text-white inline-block">{l.highlight}</span>
          </h2>
        </div>

        {/* Mobile: Mini Carousel — clipped to hide footer text */}
        <div className="block sm:hidden overflow-hidden max-h-[310px]">
          <div
            ref={mobileRef}
            className="trustpilot-widget"
            data-locale={tpLocale}
            data-template-id="539ad0ffdec7e10e686debd7"
            data-businessunit-id="60a37dbef975970001397303"
            data-style-height="350px"
            data-style-width="100%"
            data-token="c20ac5f5-3124-4eb3-b180-d84c83f88d4f"
            data-stars="4,5"
          >
            <a
              href="https://se.trustpilot.com/review/ungdomskraft.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>
        </div>

        {/* Desktop: Carousel */}
        <div className="hidden sm:block">
          <div
            ref={desktopRef}
            className="trustpilot-widget"
            data-locale={tpLocale}
            data-template-id="53aa8912dec7e10d38f59f36"
            data-businessunit-id="60a37dbef975970001397303"
            data-style-height="140px"
            data-style-width="100%"
            data-token="d7411ab0-350c-4c4b-87f7-13e43c491167"
            data-stars="1,2,3,4,5"
            data-review-languages="sv"
          >
            <a
              href="https://se.trustpilot.com/review/ungdomskraft.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
